export default __webpack_public_path__ + "../staticImages/sprite-milesmorecheckout-2x.png";